module.exports = __webpack_public_path__ + "img/kis_vw2_uj.981dcdeb.png";